import React, { useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import QRCodeStyling from "qr-code-styling";

const StyledQRCode = forwardRef(({ url, logo }, ref) => {
  const containerRef = useRef(null);
  const qrCode = useRef(null);

  useImperativeHandle(ref, () => ({
    download: (extension = 'png') => {
      if (qrCode.current) {
        qrCode.current.download({
          name: "feedback-qr-code",
          extension: extension
        });
      }
    }
  }));

  useEffect(() => {
    const currentRef = containerRef.current;
    qrCode.current = new QRCodeStyling({
      width: 250,
      height: 250,
      data: url,
      margin: 0,
      image: logo,
      qrOptions: {
        errorCorrectionLevel: "H"
      },
      dotsOptions: {
        color: "#000000",
        type: "square"
      },
      cornersSquareOptions: {
        color: "#000000",
        type: "square"
      },
      cornersDotOptions: {
        color: "#000000",
        type: "square"
      },
      backgroundOptions: {
        color: "#ffffff"
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 5
      }
    });
    qrCode.current.append(currentRef);

    return () => {
      if (currentRef) {
        currentRef.innerHTML = "";
      }
    };
  }, [url, logo]);

  useEffect(() => {
    if (qrCode.current) {
      qrCode.current.update({
        data: url,
        image: logo
      });
    }
  }, [url, logo]);

  return <div ref={containerRef} />;
});

export default StyledQRCode;
